import { apiClient } from "@api/apiClient";

const API_ENDPOINT = {
  deal: "/des/press-similar/deals",
  funding: "/des/press-similar/funding",
};

export const similarDataApis = {
  get: async (targetPressId: string, type: "deal" | "funding") => {
    const URL_BY_TYPE = {
      deal: `${API_ENDPOINT.deal}?pressId=${targetPressId}`,
      funding: `${API_ENDPOINT.funding}?pressId=${targetPressId}`,
    };
    const { data } = await apiClient.get(URL_BY_TYPE[type]);
    return data;
  },
};
